import { all, takeLatest, put } from 'redux-saga/effects';
import { setTimerValueSuccess, setEventSoundSuccess, userDetailsSuccess } from './action';
import { SET_TIMER_VALUE, SET_EVENT_AUDIO_VALUE, SEND_USER_DETAILS } from './constants';
import { requestUserDetails } from './api';

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{val, type}>>}
 */
function* sendUserDetails( actionObj ) {
    const regResult = yield requestUserDetails( actionObj.quizId, actionObj.val );
    if ( regResult ) {
        yield put( userDetailsSuccess( regResult ) );
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchSendUserDetails() {
    yield  takeLatest( SEND_USER_DETAILS, sendUserDetails );
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{val, type}>>}
 */
function* getTimerValue( actionObj ) {
    yield put( setTimerValueSuccess( actionObj.val ) );
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchTimerValue() {
    yield  takeLatest( SET_TIMER_VALUE, getTimerValue );
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{val, type}>>}
 */
function* setEventSongs( actionObj ) {
    yield put( setEventSoundSuccess( actionObj.val ) );
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchEventSoundValue() {
    yield  takeLatest( SET_EVENT_AUDIO_VALUE, setEventSongs );
}


function* timerSaga() {
    yield all( [
        watchTimerValue(),
        watchEventSoundValue(),
        watchSendUserDetails()
    ] );
}

export default timerSaga;
